"use client";

import { CarList } from "@/components/carList/carList";
import { Filters } from "@/components/filters/filters";
import { FilterAndCarsWrapper } from "@/app/(site)/components/filtersAndCarsWrapper";
import { MobileFilter } from "@/components/filters/mobile/mobileFilter";

interface Props {
  initialDepartmentIds: string[];
  departmentSlug: string;
  dealerName: string;
  isEmbedded?: boolean;
}

export const PageContent = ({
  initialDepartmentIds,
  departmentSlug,
  dealerName,
  isEmbedded = false,
}: Props) => {
  return (
    <FilterAndCarsWrapper>
      <Filters departmentSlug={departmentSlug} />
      <MobileFilter
        departmentIds={initialDepartmentIds}
        departmentSlug={departmentSlug}
      />
      <CarList
        departmentIds={initialDepartmentIds}
        departmentSlug={departmentSlug}
        dealerName={dealerName}
        isEmbedded={isEmbedded}
      />
    </FilterAndCarsWrapper>
  );
};
